import { useContext, useEffect, useState } from 'react';

import { useAuth, useSubscription } from '@chainlit/react-client';

import { useTranslation } from '@/components/i18n/Translator';

import { ChainlitContext } from 'client-types/*';

const UpgradeDashboard = () => {
  const {
    isProUser,
    subscription: _subscription,
    createCustomerSession
  } = useSubscription();
  const { user } = useAuth();
  const apiClient = useContext(ChainlitContext);
  const [customerSessionSecret, setCustomerSessionSecret] =
    useState<string>('');
  const [stripeConfig, setStripeConfig] = useState<{
    pricingTableId: string;
    publishableKey: string;
    locale: string;
  } | null>(null);
  const { t } = useTranslation();

  // Fetch app configuration
  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await fetch(apiClient.buildEndpoint('/api/config'));
        const config = await response.json();
        setStripeConfig(config.stripe);
      } catch (error) {
        console.error('Failed to fetch app config:', error);
      }
    };

    fetchConfig();
  }, [apiClient]);

  // Create customer session when component mounts
  useEffect(() => {
    const fetchCustomerSession = async () => {
      try {
        if (user) {
          const session = await createCustomerSession();
          setCustomerSessionSecret(session.client_secret);
        }
      } catch (error) {
        console.error('Failed to create customer session:', error);
      }
    };

    fetchCustomerSession();
  }, [user, createCustomerSession]);
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">
          {isProUser
            ? t('upgrade.title.changePlan')
            : t('upgrade.title.upgrade')}
        </h2>
        <p className="text-gray-600">
          {isProUser
            ? t('upgrade.description.changePlan')
            : t('upgrade.description.upgrade')}
        </p>
      </div>

      <div className="bg-white rounded-lg border border-gray-200 p-6">
        {customerSessionSecret && stripeConfig ? (
          <stripe-pricing-table
            pricing-table-id={stripeConfig.pricingTableId}
            publishable-key={stripeConfig.publishableKey}
            customer-session-client-secret={customerSessionSecret}
            data-locale={stripeConfig.locale}
          />
        ) : (
          <div className="flex items-center justify-center p-8">
            <div className="text-gray-500">{t('upgrade.loading')}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UpgradeDashboard;
